
import {baseApi, extractData} from "../api/axiosConfig";


export const getAllDataPoints = () =>
    baseApi.get("/dataPoint").then(extractData);


export const addDataPoint = data =>
    baseApi.post("/dataPoint", data).then(extractData);


export const editDataPoint = (id, data) =>
    baseApi.patch(`/dataPoint/${id}`, data).then(extractData);


export const deleteDataPoint = id =>
    baseApi.delete(`/dataPoint/${id}`).then(extractData);


export const getDataPointUseByDataPointId = id =>
    baseApi
        .get("/dataPoint/use", {
            params: { id }
        })
        .then(extractData);


export const getDataPointSectionFilterByDataPointId = dataPointId =>
    baseApi
        .get("/dataPoint/sectionFilter", {
            params: {
                id: dataPointId
            }
        })
        .then(extractData);


export const getDataPointValueFilterByDataPointId = dataPointId =>
    baseApi
        .get("/dataPoint/valueFilter", {
            params: {
                id: dataPointId
            }
        })
        .then(extractData);


export const getDataPointExpressionByDataPointId = dataPointId =>
    baseApi
        .get("/dataPoint/expression", {
            params: {
                id: dataPointId
            }
        })
        .then(extractData);


export const getDataPointsByProperty = propertyId =>
    baseApi
        .get("/dataPoint/byProperty", {
            params: {
                my_property_id: propertyId
            }
        })
        .then(extractData);


export const getDataPointsByTitle = (titleId, multiSingle) =>
    baseApi
        .get("/dataPoint/byTitle", {
            params: {
                my_title_id: titleId,
                my_multi_single: multiSingle
            }
        })
        .then(extractData);
